import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mindmap-legend-contribute",
  "use": "icon-mindmap-legend-contribute-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mindmap-legend-contribute\">\n<path d=\"M4 12H20\" stroke=\"#DFE1E6\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol